import { redirect } from 'react-router-dom';
import socket from '../../socket';

export default function Logout() {
    return (
        <div>Logout</div>
    )
}

export function logoutLoader() {
    localStorage.removeItem('isLogin');
    localStorage.removeItem('admin_rezvan_token');
    window.location.href = "/";
    return redirect('/');
}
